"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.productCompare.name': 'Product Compare',
    'tools.productCompare.description': 'Compare products from specific e-commerce domains and websites',
};
